import React, { useEffect, useState, useContext, useRef } from 'react';
import {
    Checkbox,
    Collapse,
    Row,
    Col,
    Typography,
    Button,
    Modal,
    Switch,
    Input,
    Select,
    Tooltip
} from 'antd';
import keyBy from 'lodash/keyBy';
import { updateOrCreateAnalysis, deleteAnalysis, uniqueValuesForColumn } from 'services/project';
import icon_arrow_right_white from 'images/icon_arrow_right_white.svg';
import icon_arrow_down_light from 'images/icon_arrow_down_light.svg';
import icon_circle_minus from 'images/icon_circle_minus.svg';
import icon_plus from 'images/icon_plus_in_circle.svg';
import icon_transform from 'images/icon_transform.svg';
import keys from 'lodash/keys';
import SelectDataToDisplay from 'components/modal/SelectDataToDisplay';
import icon_menu_dots_white from 'images/icon_menu_dots_white.svg';

import RenameModal from '../newModal/RenameModal';
import cloneDeep from 'lodash/cloneDeep';
import { AppContext } from 'context/AppContext';
import DeleteModal from '../newModal/DeleteModal';
import CancelModal from '../newModal/CancelModal';
import icon_right from 'images/icon_right_pop_up.svg';
import icon_x from 'images/icon_x_pop_up.svg';
import icon_y from 'images/icon_y_pop_up.svg';
import econometrica_logo_popup from 'images/eco_logo_popup.svg';
import version_pro from 'images/version_pro.svg';


import { useOnClickOutside } from 'hooks/useOnClickOutside';


const CustomIcon = () =>
(<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.6641 5.25L6.9974 9.91667L2.33073 5.25" stroke="#3D3F4D" strokeLinecap="round" strokeLinejoin="round" />
</svg>)


const Analysis = (props) => {
    let appContext = useContext(AppContext);

    // console.log(
    //     `props.analysis`,
    //     props.analysis.analysisData[props.analysis.analysisActivePanel]
    // );

    // const [copyAnalysisData, setCopyAnalysisData] = useState({});

    // useEffect(() => {
    //     if (props.analysis.analysisData[props.analysis.analysisActivePanel]) {
    //         setCopyAnalysisData(
    //             props.analysis.analysisData[props.analysis.analysisActivePanel]
    //         );
    //     }
    // }, []);

    // console.log(`copyAnalysisData`, copyAnalysisData);

    const { Panel } = Collapse;

    const [spinnerApply, setSpinnerApply] = useState(false);
    const [analysisFormErrors, setAnalysisFormErrors] = useState([]);

    const { Option } = Select;
    const [filteredColumn, setFilteredColumn] = useState(props.analysis.analysisData[props.analysis.analysisActivePanel]?.filter_by_variable?.column_index) // number column to send ex. 6
    const [filteredValue, setFilteredValue] = useState(props.analysis.analysisData[props.analysis.analysisActivePanel]?.filter_by_variable?.column_value) //value to send ex. 1369
    const [filteredColumnName, setFilteredColumnName] = useState('')
    const [filteredStatisticsColumn, setFilteredStatisticsColumn] = useState(props.analysis.analysisData[props.analysis.analysisActivePanel]?.statistics_by_variable?.column_index) // number column to send ex. 6
    const [filteredStatisticsColumnName, setFilteredStatisticsColumnName] = useState('')
    // console.log(`filteredColumn:`, filteredColumn)
    // console.log(`filteredValue:`, filteredValue)

    const [showColumnNameSelected, setShowColumnNameSelected] =
        useState('Select Column');

    let copyTableColumn = [...props.tableColumn]
    let newArrayOfColumn = []
    let newArrayOfCategoricalColumns = []
    let mapCopyTableColumn = copyTableColumn.map(item => {
        let allItem = {}
        allItem.label = item.columnName
        allItem.value = item.dataIndex
        newArrayOfColumn.push(allItem)

    })
    let mapCopyTableColumnCategorical = copyTableColumn.map(item => {
        if (item.categorical === true) {
            let allItem = {}
            allItem.label = item.columnName
            allItem.value = item.dataIndex
            newArrayOfCategoricalColumns.push(allItem)
        }
    }
    )
    newArrayOfColumn.shift()
    newArrayOfCategoricalColumns.shift()

    useEffect(() => {
        if (props.analysis.analysisData[props.analysis.analysisActivePanel]?.filter_by_variable) {
            let currentProject = localStorage.getItem('activeProject');
            let value = props.analysis.analysisData[props.analysis.analysisActivePanel].filter_by_variable_json.column_index
            uniqueValuesForColumn(currentProject, value).then(res => {
                // console.log(`uniqueValuesForColumn: `, res.data)
                let newArray = [];
                let mapObj = res.data.map((item) => {
                    newArray.push({ label: item, value: item })
                    // console.log(item)
                })

                setDataUniqueValuesForColumn(newArray)
            })
        }
    }, [props.analysis.analysisData[props.analysis.analysisActivePanel]])



    // if(props.analysis.analysisData[props.analysis.analysisActivePanel]?.filter_by_variable?.column_index){
    //     console.log(`trueeee`)
    //     let newListOfObject = {...props.analysis.analysisData}
    //     console.log(`newListOfObject:`, newListOfObject[props.analysis.analysisActivePanel])
    // //     let newNameToColumn = ''
    // //     console.log(`props.tableColumn:`,props.tableColumn )
    // //     let allActiveColumns = [...props.tableColumn]
    // //     console.log(`allActiveColumns: `, allActiveColumns[props.analysis.analysisData[props.analysis.analysisActivePanel].filter_by_variable.column_index].columnName)
    //     // let mapAllActiveColumns = allActiveColumns.map()
    //     // setShowColumnNameSelected(allActiveColumns[props.analysis.analysisData[props.analysis.analysisActivePanel].filter_by_variable.column_index].columnName)
    // }else{
    //     console.log(`falsseeee`)
    // }

    // const [scrollToFunction, setScrollToFunction] = useState([]);

    const refDrop = useRef();
    useOnClickOutside(refDrop, () => setVisibleDropdownMenuAnalysis(false));

    const refD = useRef();
    useOnClickOutside(refD, () => {
        setShowListBox(0);
        setTransformMenuIsOpen(0);
    });

    const plainOptionsUnivariate = [
        { label: 'Autoregression', value: 'autoregression' },
        { label: 'Boxplot', value: 'boxplot' },
        { label: 'Confidence Intervals', value: 'confidence_intervals' },
        { label: 'Dotplot', value: 'dotplot' },
        { label: 'Histogram', value: 'histogram' },
        { label: 'Robust Statistics', value: 'robust_statistics' },
        { label: 'Statistics', value: 'statistics' },
        { label: 'Timeplot', value: 'timeplot' },
        { label: 'Q-Q Plot', value: 'qq_plot' }
    ];

    const [visibleDropdownMenuAnalysis, setVisibleDropdownMenuAnalysis] =
        useState(false);

    const plainOptionsMultivariate = [
        { label: 'Autoregression (ARX)', value: 'autoregressionx' },
        { label: 'Regression', value: 'regression' },
        { label: 'Robust Regression', value: 'robust_regression' },
        { label: 'Scatterplot', value: 'scatterplot' },
        { label: 'Robust Scatterplot', value: 'robust_scatterplot' },
        { label: 'Weighted Scatterplot', value: 'weighted_scatterplot' },
        { label: 'Two Stage Least Squares', value: 'two_stage_least_squares' },
        { label: 'Timeplot', value: 'timeplot' }
    ];

    const transDisplayName = {
        log: 'Ln',
        lag1: 'Lag(1)',
        sqrt: 'Sqrt',
        FirstDiff: 'Diff(1)'
    };

    const [idSelectedAnalysis, setIdSelectedAnalysis] = useState(null);
    const [nameSelectedAnalysis, setNameSelectedAnalysis] = useState('');
    const [showModalGoPro, setShowModalGoPro] = useState(false);

    const duplicateAnalysisFunction = (analysisiId) => {
        let items = { ...props.analysis.analysisData };
        let item = cloneDeep(items[analysisiId]);
        delete item.id;

        const result = updateOrCreateAnalysis(item, false).then((res) => {
            const newAnalysis = res.data;

            let newAnalysisData = {
                [newAnalysis.id]: newAnalysis,
                ...props.analysis.analysisData
            };

            props.analysis.setAnalysisData(newAnalysisData);
            props.analysis.setAnalysisId(newAnalysis.id);
            props.analysis.setAnalysisActivePanel(newAnalysis.id);
            props.analysis.setRerenderAnalysisView(
                !props.analysis.rerenderAnalysisView
            );
        });
    };

    const [isModalVisibleRename, setIsModalVisibleRename] = useState(false);

    const handleChangeRename = (e) => {
        setNameSelectedAnalysis(e.target.value);
    };

    const handleOkRename = () => {
        const items = cloneDeep(props.analysis.analysisData);
        let item = items[props.analysis.analysisId];
        item['name'] = nameSelectedAnalysis;

        if (props.analysis.analysisId !== 0) {
            const result = updateOrCreateAnalysis(
                item,
                props.analysis.analysisId
            )
                .then((res) => {
                    props.analysis.setAnalysisData(items);
                })
                .finally(() => {
                    setNameSelectedAnalysis('');
                });
        } else {
            props.analysis.setAnalysisData(items);
            setNameSelectedAnalysis('');
        }
        setIsModalVisibleRename(false);
    };

    const [switchVariateType, setSwitchVariateType] = useState(null);

    const handleStartNewAnalysis = (type) => {
        let currentProject = localStorage.getItem('activeProject');
        props.analysis.setAnalysisActivePanel(0);

        let analysisDataClone = cloneDeep(props.analysis.analysisData);
        let addAnalysis = true;

        if (props.analysis.analysisData[0]?.id == 0) {
            if (props.analysis.analysisData[0].analysis_function.length == 0) {
                delete analysisDataClone[0];
            } else {
                addAnalysis = false;
                setSwitchVariateType(type);
                setIdSelectedAnalysis(0);
                setIsModalVisibleRemove(true);
            }
        }
        if (addAnalysis) {
            if (type == 'univariate') {
                props.analysis.setAnalysisData({
                    0: {
                        id: 0,
                        name: 'Univariate',
                        analysis_type: 'univariate',
                        analysis_function: [],
                        variables: {
                            Y: { trans: '', column: '' },
                            X: [],
                            settings: {
                                statistics: [
                                    'std_dev',
                                    'q1',
                                    'q3',
                                    'avg',
                                    'max',
                                    'median',
                                    'se_mean',
                                    'min',
                                    'count_total',
                                    'count_nonmissing',
                                    'count_missing'
                                ]
                            }
                        },
                        project: currentProject,
                        remove_outliers: true,
                        order: 1
                    },
                    ...analysisDataClone
                });
            } else {
                props.analysis.setAnalysisData({
                    0: {
                        id: 0,
                        name: 'Multivariate',
                        analysis_type: 'multivariate',
                        analysis_function: [],
                        variables: { Y: { trans: '', column: '' }, X: [] },
                        project: currentProject,
                        remove_outliers: true,
                        order: 1
                    },
                    ...analysisDataClone
                });
            }
        }
        appContext.setAnalysisTableChartDisplay('table');
    };

    useEffect(() => {
        if (Object.keys(props.analysis.analysisData).length === 0) {
            handleStartNewAnalysis('univariate');
        }
    }, []);

    useEffect(() => {
        if (switchVariateType !== null) {
            handleStartNewAnalysis(switchVariateType);
            setSwitchVariateType(null);
        }
    }, [props.analysis.analysisData]);

    const [isModalVisibleRemove, setIsModalVisibleRemove] = useState(false);

    const handleOkRemove = () => {
        if (props.analysis.analysisId !== 0) {
            deleteAnalysis(idSelectedAnalysis).then((res) => { });
            setIsModalVisibleRemove(false);
            props.setRerenderProjectData(!props.rerenderProjectData);
        } else {
            const items = cloneDeep(props.analysis.analysisData);
            delete items[props.analysis.analysisId];
            props.analysis.setAnalysisData(items);

            setIsModalVisibleRemove(false);
        }
    };

    const handleCancel = () => {
        setIsModalVisibleRemove(false);
        setIsModalVisibleRename(false);
        setNameSelectedAnalysis('');
    };

    let variablesNames = keyBy(props.tableColumn, 'dataIndex');

    const [showListBox, setShowListBox] = useState(0);
    const [dataUniqueValuesForColumn, setDataUniqueValuesForColumn] = useState([]);
    const [optionsSelected, setOptionsSelected] = useState([]);

    const handleSelectedColumnChange = (value) => {
        // console.log(`Im in column`)
        // console.log(`selected ${value}`);

        // setFilteredValue(value)
        // let copyAnalysisData = {...props.analysis.analysisData}
        // copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable_json.column_index = value
        // props.analysis.setAnalysisData(copyAnalysisData)
        let currentProject = localStorage.getItem('activeProject');
        uniqueValuesForColumn(currentProject, value).then(res => {
            // console.log(`uniqueValuesForColumn: `, res.data)
            let newArray = [];
            let mapObj = res.data.map((item) => {
                newArray.push({ label: item, value: item })
                // console.log(item)

            })

            setDataUniqueValuesForColumn(newArray)
        })
        // setFilteredColumn(columnIndex)
        // setShowColumnNameSelected(columnName);
        // setFilteredColumnName(columnName)
        let copyAnalysisData = { ...props.analysis.analysisData }
        copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable_json.column_index = value
        copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable_json.column_value = null
        // copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable = {column_index: columnIndex, column_value: ''}
        props.analysis.setAnalysisData(copyAnalysisData)



    };

    const handleSelectedStatisticsByColumnChange = (value) => {
        let currentProject = localStorage.getItem('activeProject');
        uniqueValuesForColumn(currentProject, value).then(res => {
            // console.log(`uniqueValuesForColumn: `, res.data)
            let newArray = [];
            let mapObj = res.data.map((item) => {
                newArray.push({ label: item, value: item })
                // console.log(item)

            })

            setDataUniqueValuesForColumn(newArray)
        })
        let copyAnalysisData = { ...props.analysis.analysisData }
        copyAnalysisData[props.analysis.analysisActivePanel].statistics_by_variable_json.column_index = value
        props.analysis.setAnalysisData(copyAnalysisData)



    };


    const handleSelectedUniqueChange = (value) => {
        // console.log(`selected ${value}`);
        // setOptionsSelected(value)
        setFilteredValue(value)
        let copyAnalysisData = { ...props.analysis.analysisData }
        copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable_json.column_value = value
        props.analysis.setAnalysisData(copyAnalysisData)
    };

    //   console.log(`props.analysis.analysisData:`,props.analysis.analysisData)
    //   console.log(`props.analysis.rawAnalysisData:`,props.analysis.rawAnalysisData)


    // const [showColumnNameSelected, setShowColumnNameSelected] =
    //     useState(`C${props.analysis.analysisData[props.analysis.analysisActivePanel].filter_by_variable.column_index}`);

    const handelColumnSelection = (columnIndex, columnName) => {
        setShowColumnNameSelected(columnName);
        props.analysis.handleSetVariable(columnIndex, columnName);
    };

    const handelColumnSelectionForFiltered = (columnIndex, columnName) => {

        // console.log(`columnIndex: ${columnIndex}, columnName: ${columnName} `)
        let currentProject = localStorage.getItem('activeProject');
        uniqueValuesForColumn(currentProject, columnIndex).then(res => {
            // console.log(`uniqueValuesForColumn: `, res.data)
            let newArray = [];
            let mapObj = res.data.map((item) => {
                newArray.push({ label: item, value: item })
                // console.log(item)

            })

            setDataUniqueValuesForColumn(newArray)
        })
        setFilteredColumn(columnIndex)
        // setShowColumnNameSelected(columnName);
        setFilteredColumnName(columnName)
        let copyAnalysisData = { ...props.analysis.analysisData }
        copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable_json.column_index = columnIndex
        copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable_json.column_value = ""
        // copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable = {column_index: columnIndex, column_value: ''}
        props.analysis.setAnalysisData(copyAnalysisData)
        // props.analysis.handleSetVariable(columnIndex, columnName);
    };

    useEffect(() => {
        console.log(`rerender aplication`)
    }, [dataUniqueValuesForColumn])

    // console.log(`props.analysis:`,props.analysis)
    // console.log(`dataUniqueValuesForColumn:`,dataUniqueValuesForColumn)
    // console.log(`props:`, props)
    // console.log(`props.analysis:`, props.analysis)
    // console.log(`props.analysis Active Panel:`, props.analysis.analysisData[props.analysis.analysisActivePanel])
    // console.log(`props.analysis.analysisActivePanel:`, props.analysis.analysisActivePanel)

    const tableColumnsDisplay = (tableColumnList) => {
        let columnList = [];
        for (let columnIndex in tableColumnList) {
            if (tableColumnList[columnIndex].type === 'NUMBER') {
                columnList.push(
                    <li
                        key={columnIndex}
                        onClick={() => {
                            handelColumnSelection(
                                tableColumnList[columnIndex].dataIndex,
                                tableColumnList[columnIndex].columnName
                            );
                            setShowListBox(0);
                        }}
                    >
                        {tableColumnList[columnIndex].columnName}
                    </li>
                );
            }
        }

        return columnList;
    };

    const handleTimeplotXAxisTypeSelection = (xAxisType) => {
        handleTimeplotXAxisTypeChange({ target: { value: xAxisType } });
        setShowListBox(0);
    };

    const handleTimeplotTimeColumnSelection = (columnIndex, columnName) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];

        // Store in variables JSONField instead of separate field
        if (!item.variables.timeplot_xaxis_type) {
            item.variables.timeplot_xaxis_type = {};
        }
        if (!item.variables.timeplot_xaxis_type.time_column_json) {
            item.variables.timeplot_xaxis_type.time_column_json = {};
        }
        item.variables.timeplot_xaxis_type.time_column_json.column_index = columnIndex;

        props.analysis.setAnalysisData(items);
        setShowListBox(0);

        // Clear error if exists
        let newAnalysisFormErrors = [...analysisFormErrors];
        newAnalysisFormErrors = newAnalysisFormErrors.filter((item) => {
            return item != 'timeplotTimeColumn';
        });
        setAnalysisFormErrors(newAnalysisFormErrors);
    };

    const xAxisTypeOptions = [
        { value: 'index', label: 'Index' },
        { value: 'year', label: 'Date' }
    ];

    const xAxisTypeList = xAxisTypeOptions.map((option) => (
        <li
            key={option.value}
            onClick={() => {
                handleTimeplotXAxisTypeSelection(option.value);
            }}
        >
            {option.label}
        </li>
    ));

    const tableColumnsDisplayForTimeColumn = (tableColumnList) => {
        let columnList = [];
        for (let columnIndex in tableColumnList) {
            // Exclude "index" column from time column selection
            const columnName = tableColumnList[columnIndex].columnName;
            if (columnName && columnName.toLowerCase() === 'index') {
                continue;
            }
            columnList.push(
                <li
                    key={columnIndex}
                    onClick={() => {
                        handleTimeplotTimeColumnSelection(
                            tableColumnList[columnIndex].dataIndex,
                            tableColumnList[columnIndex].columnName
                        );
                    }}
                >
                    {columnName}
                </li>
            );
        }
        return columnList;
    };

    let availableColumnListForTimeColumn = tableColumnsDisplayForTimeColumn(props.tableColumn);

    const tableColumnsDisplayForFiltered = (tableColumnList) => {
        let columnList = [];
        for (let columnIndex in tableColumnList) {
            // if (tableColumnList[columnIndex].type === 'NUMBER') {
            columnList.push(
                <li
                    key={columnIndex}
                    onClick={() => {
                        handelColumnSelectionForFiltered(
                            tableColumnList[columnIndex].dataIndex,
                            tableColumnList[columnIndex].columnName
                        );
                        setShowListBox(0);
                    }}
                >
                    {tableColumnList[columnIndex].columnName}
                </li>
            );
            // }
        }

        return columnList;
    };

    const handleShowListBox = (boxId) => {
        setTransformMenuIsOpen(0);
        if (showListBox === boxId) {
            setShowListBox(0);
        } else {
            setShowListBox(boxId);
            handleInputVariable(boxId);
        }
    };

    let availableColumnList = tableColumnsDisplay(props.tableColumn);
    let availableColumnListForFiltered = tableColumnsDisplayForFiltered(props.tableColumn);

    const panelHeaderInactive = (text, keyId) => {
        let textToString = String(text);

        return (
            <>
                <Row onClick={(event) => event.stopPropagation()}>
                    <Col style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            style={{ marginRight: 10 }}
                            src={icon_arrow_right_white}
                        />
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <div style={{ color: 'white' }}>
                                {textToString.length >= 18
                                    ? textToString.substring(0, 18) + '...'
                                    : textToString}
                            </div>
                        </div>
                    </Col>
                    <div
                        ref={refDrop}
                        style={{
                            display: 'flex',
                            justifyContent: 'center',

                            position: 'absolute',
                            top: '8px',
                            right: '-12px'
                            // zIndex: 100
                        }}
                        className="dropdown"
                        onClick={() => {
                            setVisibleDropdownMenuAnalysis(
                                !visibleDropdownMenuAnalysis
                            );
                        }}
                    >
                        <Button
                            style={{
                                border: 'none',
                                backgroundColor: 'transparent',
                                boxShadow: 'none'
                            }}
                            shape="circle"
                        >
                            <img
                                src={icon_menu_dots_white}
                                className="icon-menu-dots-svg"
                            />
                        </Button>
                        <div
                            className={
                                // 'dropdown-content-visible'
                                visibleDropdownMenuAnalysis
                                    ? 'dropdown-content-visible'
                                    : 'dropdown-content-invisible'
                            }
                            style={{
                                right: '0px',
                                bottom: keyId == 0 ? '-75px' : '-108px',
                                width: 'auto',
                                fontSize: '12px',
                                padding: '0 4px',
                                minWidth: 0
                            }}
                        >
                            <button
                                onClick={(e) => {
                                    setNameSelectedAnalysis(textToString);
                                    setIsModalVisibleRename(true);
                                    // RenameAnalysis(keyId);
                                }}
                                className="button-dropdown"
                                style={{ paddingTop: 9 }}
                            >
                                Rename Analysis
                            </button>
                            {keyId != 0 && (
                                <button
                                    onClick={() => {
                                        duplicateAnalysisFunction(keyId);
                                    }}
                                    className="button-dropdown"
                                // style={{ padding: '5px' }}
                                >
                                    Duplicate Analysis
                                </button>
                            )}
                            {/* <button
                                onClick={() => {
                                    // ExportAnalysis(keyId);
                                }}
                                className="button-dropdown"
                                // style={{ padding: '5px' }}
                            >
                                Export Analysis
                            </button> */}
                            <button
                                className="button-dropdown"
                                style={{ paddingBottom: 7 }}
                                onClick={() => {
                                    if (
                                        props.analysis.analysisData[
                                            props.analysis.analysisActivePanel
                                        ].analysis_function.length == 0 &&
                                        props.analysis.analysisActivePanel == 0
                                    ) {
                                        handleOkRemove();
                                    } else {
                                        setIdSelectedAnalysis(keyId);
                                        setIsModalVisibleRemove(true);
                                    }
                                }}
                            >
                                {keyId == 0
                                    ? 'Discard Analysis'
                                    : 'Delete Analysis'}
                            </button>
                        </div>
                    </div>
                </Row>
            </>
        );
    };

    const panelHeaderActive = (text, keyId) => {
        return (
            <>
                <Row
                    onClick={() => {
                        props.analysis.setAnalysisActivePanel(keyId);
                        setNameSelectedAnalysis('');
                        // props.setRerenderApply(!props.rerenderApply);
                    }}
                >
                    <Col style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            style={{
                                marginRight: 10,
                                transform: 'rotate(-90deg)'
                            }}
                            src={icon_arrow_right_white}
                        />
                        <Typography.Text>{text}</Typography.Text>
                    </Col>
                </Row>
            </>
        );
    };

    const sendDataUpdateAnalysis = async (
        analysisId,
        analysis_function,
        variables,
        name,
        project,
        analysis_type,
        remove_outliers,
        filter_by_variable,
        filter_by_variable_json,
        statistics_by_variable,
        statistics_by_variable_json

    ) => {
        // console.log(`analysisId:`, analysisId)
        // console.log(`analysis_function:`, analysis_function)
        // console.log(`variables:`, variables)
        // console.log(`name:`, name)
        // console.log(`project:`, project)
        // console.log(`analysis_type:`, analysis_type)
        // console.log(`remove_outliers:`, remove_outliers)
        // console.log(`filter_by_variable:`, filter_by_variable)
        // console.log(`filter_by_variable_json:`, filter_by_variable_json)
        setSpinnerApply(true);


        let data = {
            analysis_function: analysis_function,
            variables: variables,
            name: name,
            project: project,
            analysis_type: analysis_type,
            remove_outliers: remove_outliers,
            filter_by_variable: filter_by_variable,
            filter_by_variable_json: filter_by_variable_json,
            statistics_by_variable: statistics_by_variable,
            statistics_by_variable_json: statistics_by_variable_json
        };

        let dataError = true;
        let dataErrorMsg = [];

        if (variables.Y.column === '') {
            dataError = false;
            //dataErrorMsg.push('Please provide dependent variable');
            dataErrorMsg.push('dependent');
        }

        if (analysis_type === 'multivariate') {
            let minVariables =
                props.analysis.analysisFunctionOptions[analysis_function[0]]
                    .min_independent_var;

            if (variables.X.length < minVariables) {
                dataError = false;
                //dataErrorMsg.push('Please provide independent variable');
                dataErrorMsg.push('independent');
            }
        }

        if (!analysis_function.length) {
            dataError = false;
            //dataErrorMsg.push('Please select statistical function');
            dataErrorMsg.push('function');
        }

        if (filter_by_variable) {
            if (filter_by_variable_json.column_index === null) {
                dataError = false
                dataErrorMsg.push('filteredColumn');
            }
            if (filter_by_variable_json.column_value === null) {
                dataError = false
                dataErrorMsg.push('filteredValue');
            }
        }

        // Validate timeplot x-axis type selection
        if (analysis_function.includes('timeplot') && variables.timeplot_xaxis_type) {
            if (variables.timeplot_xaxis_type.type === 'year') {
                if (!variables.timeplot_xaxis_type.time_column_json ||
                    variables.timeplot_xaxis_type.time_column_json.column_index === null) {
                    dataError = false;
                    dataErrorMsg.push('timeplotTimeColumn');
                }
            }
        }

        if (
            JSON.stringify(props.analysis.rawAnalysisData) ===
            JSON.stringify(props.analysis.analysisData)
        ) {
            // console.log(`setchartView`);
            setSpinnerApply(false);
        } else {
            if (dataError) {
                const result = updateOrCreateAnalysis(data, analysisId).then(
                    (res) => {
                        const newAnalysis = res.data;

                        let newAnalysisData = {
                            [newAnalysis.id]: newAnalysis,
                            ...props.analysis.analysisData
                        };
                        // removing analysis id 0 after getting for it true id
                        delete newAnalysisData[0];

                        props.analysis.setAnalysisData(newAnalysisData);
                        props.analysis.setAnalysisId(newAnalysis.id);

                        props.analysis.setAnalysisActivePanel(newAnalysis.id);
                        props.analysis.setRerenderAnalysisView(
                            !props.analysis.rerenderAnalysisView
                        );
                        setSpinnerApply(false);

                        if (res.status == 200) {
                            props.setSpinnerFullProjectView(true);
                            setNameSelectedAnalysis('');
                        }
                    }
                );
            }
        }

        if (!dataError) {
            setSpinnerApply(false);

            setAnalysisFormErrors(dataErrorMsg);
            setTimeout(() => {
                setAnalysisFormErrors([]);
            }, 3000);
        }

        appContext.setAnalysisTableChartDisplay('chart');
    };

    const handleInputVariable = (variable) => {
        // console.log(`variable:`, variable)
        let obj = { ...props.analysis.defaultInputVariableTaker };
        obj.analysis_id = props.analysis.analysisId;
        obj.taker = true;
        obj.variable = variable;
        props.analysis.setInputVariableTaker(obj);
    };

    const handleDeleteDependentVariable = () => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];
        item.variables['Y'].column = '';
        item.variables['Y'].trans = '';
        props.analysis.setAnalysisData(items);
        props.analysis.setInputVariableTaker(
            props.analysis.defaultInputVariableTaker
        );
    };

    const handleDeleteInstrumentVariable = (columnIndex) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];
        const zList = Array.isArray(item.variables['Z']) ? item.variables['Z'] : [];
        item.variables['Z'] = zList.filter(
            (el) => parseInt(el.column) !== parseInt(columnIndex)
        );
        props.analysis.setAnalysisData(items);
        props.analysis.setInputVariableTaker(
            props.analysis.defaultInputVariableTaker
        );
    };

    const [transformMenuIsOpen, setTransformMenuIsOpen] = useState(false);

    const handleOpenAndCloseTransformMenu = (columnIndex) => {
        setShowListBox(0);
        if (transformMenuIsOpen !== columnIndex) {
            setTransformMenuIsOpen(columnIndex);
        } else {
            setTransformMenuIsOpen(0);
        }
    };
    const transformMenuDisplay = (shwoIdMenu) => {
        if (shwoIdMenu !== transformMenuIsOpen) return 'd-none';

        return 'transform-menu-container';
    };

    const handleVariableTransformation = (
        variableType,
        columnIndex,
        transform
    ) => {

        // console.log(variableType,columnIndex,transform)
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];

        console.log(`item.............`, item)

        if (variableType === 'dependent') {
            item.variables.Y.trans = transform;

            if (transform == 'FirstDiff') {
                console.log(`FirstDiff true`)
                item.variables.X.map(i => {
                    i.trans = 'FirstDiff'
                })

            } else {
                item.variables.X.map(i => {
                    i.trans = ''
                })
            }

        } else {
            let xItems = item.variables.X;
            for (let i in xItems) {
                let xItem = xItems[i];
                // Convert both to strings for comparison to handle number/string mismatches
                if (String(xItem.column) == String(columnIndex)) {
                    xItem.trans = transform;
                }
            }

            if (transform == 'FirstDiff') {
                item.variables.Y.trans = 'FirstDiff'

                item.variables.X.map(i => {
                    i.trans = 'FirstDiff'
                })

            } else {
                if (item.variables.Y.trans == 'FirstDiff') {
                    item.variables.Y.trans = ''
                }
                item.variables.X.map(i => {
                    if (i.trans == 'FirstDiff') {
                        i.trans = ''
                    }
                })
            }

        }

        props.analysis.setAnalysisData(items);
        setTransformMenuIsOpen(0);
    };

    const handelUnivariateFunctionSelect = (analysisFunctionList) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];
        let difference = analysisFunctionList.filter(
            (x) => !item.analysis_function.includes(x)
        );
        item.analysis_function = analysisFunctionList;

        // Initialize timeplot_xaxis_type when timeplot is selected
        if (analysisFunctionList.includes('timeplot')) {
            if (!item.variables.timeplot_xaxis_type) {
                item.variables.timeplot_xaxis_type = {
                    type: 'index',
                    time_column_json: { column_index: null }
                };
            }
        }

        if (difference.length) {
            props.setScrollToFunction(difference[0]);
        }

        props.analysis.setAnalysisData(items);
    };

    const handelRemoveOutliersChange = (checked) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];
        // console.log(`items[props.analysis.analysisId]`,items[props.analysis.analysisId])
        item.remove_outliers = checked;

        props.analysis.setAnalysisData(items);
    };

    const handelFilterByCatgoryChange = (checked) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];
        item.filter_by_variable = checked;
        item.filter_by_variable_json = { column_index: null, column_value: null };


        // let copyAnalysisData = {...props.analysis.analysisData}
        // copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable = {column_index: null, column_value: null}
        // props.analysis.setAnalysisData(copyAnalysisData)

        props.analysis.setAnalysisData(items);
    };

    const handleStatisticsByVariableChange = (checked) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];
        item.statistics_by_variable = checked;
        item.statistics_by_variable_json = { column_index: null };


        // let copyAnalysisData = {...props.analysis.analysisData}
        // copyAnalysisData[props.analysis.analysisActivePanel].filter_by_variable = {column_index: null, column_value: null}
        // props.analysis.setAnalysisData(copyAnalysisData)

        props.analysis.setAnalysisData(items);
    };

    const handelMultivariateFunctionSelect = (analysisFunctionList) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];

        analysisFunctionList = analysisFunctionList.filter(
            (el) => !item.analysis_function.includes(el)
        );
        item.analysis_function = analysisFunctionList;

        if (item.analysis_function.length) {
            let maxVariables =
                props.analysis.analysisFunctionOptions[
                    item.analysis_function[0]
                ].max_independent_var;

            if (item.variables.X.length > maxVariables) {
                item.variables.X = [item.variables.X[0]];
            }

            if (item.analysis_function.includes('two_stage_least_squares')) {
                if (!Array.isArray(item.variables.Z)) {
                    item.variables.Z = [];
                }
            } else if (item.variables.Z !== undefined) {
                delete item.variables.Z;
            }
        }

        props.analysis.setAnalysisData(items);
    };

    const handleTimeplotVariableSelect = (selectedColumns) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];

        // Clear existing variables
        item.variables.Y.column = '';
        item.variables.Y.trans = '';
        item.variables.X = [];

        // Set Y as first selected column, X as the rest
        if (selectedColumns && selectedColumns.length > 0) {
            item.variables.Y.column = selectedColumns[0].toString();
            item.variables.Y.trans = '';

            // Add remaining columns as X variables
            for (let i = 1; i < selectedColumns.length; i++) {
                item.variables.X.push({
                    column: selectedColumns[i].toString(),
                    trans: ''
                });
            }
        }

        props.analysis.setAnalysisData(items);
    };

    const handleDeleteTimeplotVariable = (columnIndex) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];

        // If deleting Y variable, move first X to Y if exists
        if (item.variables.Y.column === columnIndex.toString()) {
            if (item.variables.X.length > 0) {
                item.variables.Y.column = item.variables.X[0].column;
                item.variables.Y.trans = item.variables.X[0].trans;
                item.variables.X = item.variables.X.slice(1);
            } else {
                item.variables.Y.column = '';
                item.variables.Y.trans = '';
            }
        } else {
            // Delete from X variables
            item.variables.X = item.variables.X.filter(
                (el) => parseInt(el.column) !== parseInt(columnIndex)
            );
        }

        props.analysis.setAnalysisData(items);
    };

    const handleTimeplotXAxisTypeChange = (e) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];

        // Store in variables JSONField instead of separate field
        if (!item.variables.timeplot_xaxis_type) {
            item.variables.timeplot_xaxis_type = {};
        }
        item.variables.timeplot_xaxis_type.type = e.target.value;

        // If switching to Index, clear time column selection
        if (e.target.value === 'index') {
            if (item.variables.timeplot_xaxis_type.time_column_json) {
                item.variables.timeplot_xaxis_type.time_column_json = { column_index: null };
            }
        }

        props.analysis.setAnalysisData(items);
    };

    const handleTimeplotTimeColumnChange = (columnIndex) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];

        // Store in variables JSONField instead of separate field
        if (!item.variables.timeplot_xaxis_type) {
            item.variables.timeplot_xaxis_type = {};
        }
        if (!item.variables.timeplot_xaxis_type.time_column_json) {
            item.variables.timeplot_xaxis_type.time_column_json = {};
        }
        item.variables.timeplot_xaxis_type.time_column_json.column_index = columnIndex;

        props.analysis.setAnalysisData(items);
    };

    const handleDeleteIndependentVariable = (columnIndex) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];

        item.variables['X'] = item.variables['X'].filter(
            (el) => parseInt(el.column) != parseInt(columnIndex)
        );

        props.analysis.setAnalysisData(items);
    };

    const handleSetStatistics = (analysisId, statistics) => {
        let items = { ...props.analysis.analysisData };
        let item = items[props.analysis.analysisId];

        item.variables['settings'] = {};
        item.variables['settings']['statistics'] = statistics;

        props.analysis.setAnalysisData(items);
    };

    let analysisOrder = keys(props.analysis.analysisData)
        .map((i) => Number(i))
        .sort((a, b) => a - b)
        .reverse();

    if (analysisOrder.slice(-1)[0] === 0) {
        analysisOrder.unshift(analysisOrder.pop());
    }

    let analysisData = analysisOrder.map((key, index) => {
        const item = props.analysis.analysisData[key];

        // console.log(`item:`,item)
        // console.log(`props.analysis.analysisActivePanel:`,props.analysis.analysisActivePanel)

        const analysisTypeUnivariate =
            item.analysis_type === 'univariate'
                ? 'analysis-type-active'
                : 'analysis-type-inactive';
        const analysisTypeMultivariate =
            item.analysis_type === 'multivariate'
                ? 'analysis-type-active'
                : 'analysis-type-inactive';

        const inputVariableTaker = props.analysis.inputVariableTaker;

        let dependentVariableClass = ['dependent-variable-box'];

        if (
            item.id === inputVariableTaker.analysis_id &&
            inputVariableTaker.variable === 'Y' &&
            inputVariableTaker.taker
        )
            dependentVariableClass.push('red-border');

        dependentVariableClass = dependentVariableClass.join(' ');

        let dependentVariable = (
            <div
                className="dependent-variable"
                onClick={() => {
                    handleInputVariable('Y');
                }}
            >
                <div className="title-add">Click column to select variable</div>
            </div>
        );

        dependentVariable = (
            <Tooltip
                visible={
                    analysisFormErrors.includes('dependent') ? true : false
                }
                placement="right"
                color="#fff"
                title={() => {
                    return (
                        <div
                            style={{
                                padding: '14px 12px',
                                color: '#3D3F4D',
                                fontFamily: 'Roboto Medium',
                                fontSize: '14px',
                                lineHeight: '17px'
                            }}
                        >
                            Please provide dependent variable
                        </div>
                    );
                }}
            >
                <div className="project-conditional-card">
                    <div
                        onClick={() => {
                            handleShowListBox('Y');
                            let newAnalysisFormErrors = [...analysisFormErrors];
                            newAnalysisFormErrors =
                                newAnalysisFormErrors.filter((item) => {
                                    return item != 'dependent';
                                });

                            setAnalysisFormErrors(newAnalysisFormErrors);
                        }}
                        className="select-box-white"
                    >
                        <div
                            className="title-var-right"
                            style={{ width: 'auto' }}
                        >
                            Select column
                        </div>
                        <div>
                            <img
                                className="icon-arrow-down"
                                src={icon_arrow_down_light}
                            />
                        </div>
                    </div>
                    <div
                        className={
                            showListBox === 'Y'
                                ? 'select-list-box-white'
                                : 'd-none'
                        }
                    >
                        <ul
                            style={{ marginLeft: '-230px', maxHeight: '300px' }}
                            onClick={() => {
                                handleShowListBox('Y');
                            }}
                        >
                            {availableColumnList}
                        </ul>
                    </div>
                </div>
            </Tooltip>
        );

        let filteredColumnTooltip = (
            <Tooltip
                visible={
                    analysisFormErrors.includes('filteredColumn') ? true : false
                }
                placement="right"
                color="#fff"
                title={() => {
                    return (
                        <div
                            style={{
                                padding: '14px 12px',
                                color: '#3D3F4D',
                                fontFamily: 'Roboto Medium',
                                fontSize: '14px',
                                lineHeight: '17px'
                            }}
                        >
                            Please provide Filter Column
                        </div>
                    );
                }}
            >
            </Tooltip>
        );

        let filteredVariableTooltip = (
            <Tooltip
                visible={
                    analysisFormErrors.includes('filteredValue') ? true : false
                }
                placement="rightTop"
                color="#fff"
                title={() => {
                    return (
                        <div
                            style={{
                                padding: '14px 12px',
                                color: '#3D3F4D',
                                fontFamily: 'Roboto Medium',
                                fontSize: '14px',
                                lineHeight: '17px'
                            }}
                        >
                            Please provide Filter Value
                        </div>
                    );
                }}
            >
            </Tooltip>
        );

        // let yVariable = item.variables.Y.column;

        console.log(`item..`, item)

        let yVariable = item.variables.Y;
        if (yVariable.column) {
            // props.setChartVariableName(
            //     String(
            //         variablesNames[yVariable.column]
            //             .columnName
            //     )
            // );
            console.log(yVariable, item.variables);
            dependentVariable = (
                <>
                    <div className={dependentVariableClass}>
                        <div
                            className="dependent-variable"
                            onClick={() => {
                                handleInputVariable('Y');
                            }}
                            key={item.id}
                        >
                            <div
                                className="title"
                                onClick={() => {
                                    handleShowListBox('Y');
                                }}
                            >
                                {yVariable.trans
                                    ? transDisplayName[yVariable.trans] + ' | '
                                    : null}
                                {variablesNames[yVariable.column].columnName}
                            </div>
                            <div className="icons">
                                <Tooltip placement="top" title='Add Transform'>
                                    <img
                                        className="icon-transform"
                                        onClick={() => {
                                            handleOpenAndCloseTransformMenu(
                                                yVariable.column
                                            );
                                        }}
                                        src={icon_transform}
                                    />
                                </Tooltip>
                                <Tooltip placement="top" title='Remove Dependent Variable'>
                                    <img
                                        onClick={() => {
                                            handleDeleteDependentVariable();
                                        }}
                                        src={icon_circle_minus}
                                    />
                                </Tooltip>

                            </div>
                        </div>
                    </div>
                    <div className="project-conditional-card">
                        <div
                            className={
                                showListBox === 'Y'
                                    ? 'select-list-box-white'
                                    : 'd-none'
                            }
                        >
                            <ul
                                style={{ marginLeft: '0px', marginTop: -6 }}
                                onClick={() => {
                                    handleShowListBox('Y');
                                }}
                            >
                                {availableColumnList}
                            </ul>
                        </div>
                    </div>
                </>
            );
        }

        let transformMenu = 'd-none';
        if (transformMenuIsOpen) transformMenu = 'transform-menu-container';

        let independentVariableClass = ['independent-variables-box'];

        if (
            item.id === inputVariableTaker.analysis_id &&
            inputVariableTaker.variable === 'X' &&
            inputVariableTaker.taker
        )
            independentVariableClass.push('red-border');

        independentVariableClass = independentVariableClass.join(' ');

        let independentVariables = (
            <>
                <div
                    style={{ marginTop: '6px' }}
                    className="independent-variables"
                    onClick={() => {
                        handleInputVariable('Y');
                    }}
                >
                    <div className="title-add">
                        Click column to select variable
                    </div>
                </div>
            </>
        );

        const independentVariablesSelect = (
            <div
                className={
                    item.variables.X.lenght === 0
                        ? 'project-conditional-card-top'
                        : 'project-conditional-card-top'
                }
            >
                <Tooltip
                    visible={
                        analysisFormErrors.includes('independent')
                            ? true
                            : false
                    }
                    placement="right"
                    color="#fff"
                    title={() => {
                        return (
                            <div
                                style={{
                                    padding: '14px 12px',
                                    color: '#3D3F4D',
                                    fontFamily: 'Roboto Medium',
                                    fontSize: '14px',
                                    lineHeight: '17px'
                                }}
                            >
                                Please provide independent variable
                            </div>
                        );
                    }}
                >
                    <div
                        onClick={() => {
                            handleShowListBox('X');
                            let newAnalysisFormErrors = [...analysisFormErrors];
                            newAnalysisFormErrors =
                                newAnalysisFormErrors.filter((item) => {
                                    return item != 'independent';
                                });

                            setAnalysisFormErrors(newAnalysisFormErrors);
                        }}
                        className="select-box-white-border"
                    >
                        <div
                            className="title-var-right"
                            style={{ width: 'auto' }}
                        >
                            Select column
                        </div>
                        <div>
                            <img
                                className="icon-arrow-down"
                                src={icon_arrow_down_light}
                            />
                        </div>
                    </div>
                </Tooltip>
                <div
                    className={
                        showListBox === 'X' ? 'select-list-box-white' : 'd-none'
                    }
                >
                    <ul
                        style={{ marginLeft: '-230px', maxHeight: '300px', overflow: 'auto' }}
                        onClick={() => {
                            handleShowListBox('X');
                        }}
                    >
                        {availableColumnList}
                    </ul>
                </div>
            </div>
        );

        independentVariables = independentVariablesSelect;

        let maxVariables = '';
        if (item.analysis_type === 'multivariate') {
            const xVariables = item.variables.X;

            if (xVariables.length && item.analysis_function.length) {
                maxVariables =
                    props.analysis.analysisFunctionOptions[
                        item.analysis_function[0]
                    ].max_independent_var;

                independentVariables = [];
                // for (let item in xVariables) {
                //     let xVar = xVariables[item];
                //     let varName = variablesNames[xVar.column].columnName;
                //     independentVariables.unshift(
                //         <div key={item}>
                //             <div className="independent-variables">
                //                 <div className="title">{varName}</div>
                //                 <div className="icons">
                //                     <img
                //                         onClick={() => {
                //                             handleOpenAndCloseTransformMenu(
                //                                 xVar.column
                //                             );
                //                         }}
                //                         className="icon-transform"
                //                         src={icon_transform}
                //                     />
                //                     <img
                //                         onClick={() => {
                //                             handleDeleteIndependentVariable(
                //                                 xVar.column
                //                             );
                //                         }}
                //                         src={icon_circle_minus}
                //                     />
                //                 </div>
                //             </div>
                //             {/* Submenu */}
                //             <div
                //                 style={{ marginLeft: '-5px' }}
                //                 className={
                //                     transformMenuIsOpen === xVar.column
                //                         ? 'transform-menu-container'
                //                         : 'd-none'
                //                 }
                //             >
                //                 <div className="transform-menu-box">
                //                     <ul>
                //                         <li
                //                             onClick={() => {
                //                                 handleVariableTransformation(
                //                                     'independent',
                //                                     xVar.column,
                //                                     'log'
                //                                 );
                //                             }}
                //                         >
                //                             Ln
                //                         </li>
                //                         {/* <li
                //                             onClick={() => {
                //                                 handleVariableTransformation(
                //                                     'independent',
                //                                     xVar.column,
                //                                     'lag1'
                //                                 );
                //                             }}
                //                         >
                //                             Lag(1)
                //                         </li> */}
                //                         {/* <li
                //                                     onClick={() => {
                //                                         handleVariableTransformation(
                //                                             'dependent',
                //                                             item.id,
                //                                             'sqrt'
                //                                         );
                //                                     }}
                //                                 >
                //                                     Sqrt
                //                                 </li> */}
                //                         <li
                //                             onClick={() => {
                //                                 handleVariableTransformation(
                //                                     'independent',
                //                                     xVar.column,
                //                                     ''
                //                                 );
                //                             }}
                //                         >
                //                             None
                //                         </li>
                //                     </ul>
                //                 </div>
                //             </div>
                //             {/* Submenu End */}
                //             {maxVariables === 1 ? null : <hr></hr>}
                //         </div>
                //     );
                // }
                const isTslsAnalysis = item.analysis_function.includes(
                    'two_stage_least_squares'
                );
                for (let xIdx in xVariables) {
                    let xVar = xVariables[xIdx];
                    let varName = variablesNames[xVar.column]?.columnName;
                    let transVarName = '';
                    console.log(xVariables[xIdx].trans)
                    if (xVariables[xIdx].trans == 'log') {
                        transVarName = `Ln | ${varName}`;
                    }
                    else if (xVariables[xIdx].trans == 'FirstDiff') {
                        transVarName = `Diff(1) | ${varName}`;
                    }
                    else if (xVariables[xIdx].trans == 'lag1') {
                        transVarName = `Lag(1) | ${varName}`;
                    }
                    else {
                        transVarName = `${varName}`;
                    }

                    if (isTslsAnalysis) {
                        const role =
                            parseInt(xIdx, 10) === 0
                                ? 'Endog'
                                : 'Exog';
                        transVarName = `${role} | ${transVarName}`;
                    }

                    // independentVariables.unshift(
                    independentVariables.push(
                        <div key={xIdx}>
                            <div className="independent-variables">
                                <div className="title">
                                    {/* {varName} */}
                                    {transVarName}
                                </div>
                                <div className="icons">
                                    <img
                                        onClick={() => {
                                            handleOpenAndCloseTransformMenu(
                                                xVar.column
                                            );
                                        }}
                                        className="icon-transform"
                                        src={icon_transform}
                                    />
                                    <img
                                        onClick={() => {
                                            handleDeleteIndependentVariable(
                                                xVar.column
                                            );
                                        }}
                                        src={icon_circle_minus}
                                    />
                                </div>
                            </div>
                            {/* Submenu */}
                            <div
                                style={{ marginLeft: '-5px' }}
                                className={
                                    transformMenuIsOpen === xVar.column
                                        ? 'transform-menu-container'
                                        : 'd-none'
                                }
                            >
                                <div className="transform-menu-box">
                                    <ul>
                                        <li
                                            onClick={() => {
                                                handleVariableTransformation(
                                                    'independent',
                                                    xVar.column,
                                                    'log'
                                                );
                                            }}
                                        >
                                            Ln
                                        </li>
                                        <li
                                            onClick={() => {
                                                handleVariableTransformation(
                                                    'independent',
                                                    xVar.column,
                                                    'FirstDiff'
                                                );
                                            }}
                                        >
                                            First Difference
                                        </li>
                                        {isTslsAnalysis ? (
                                            <li
                                                onClick={() => {
                                                    handleVariableTransformation(
                                                        'independent',
                                                        xVar.column,
                                                        'lag1'
                                                    );
                                                }}
                                            >
                                                Lag(1)
                                            </li>
                                        ) : null}
                                        {/* <li
                                            onClick={() => {
                                                handleVariableTransformation(
                                                    'independent',
                                                    xVar.column,
                                                    'lag1'
                                                );
                                            }}
                                        >
                                            Lag(1)
                                        </li> */}
                                        {/* <li
                                                    onClick={() => {
                                                        handleVariableTransformation(
                                                            'dependent',
                                                            item.id,
                                                            'sqrt'
                                                        );
                                                    }}
                                                >
                                                    Sqrt
                                                </li> */}
                                        <li
                                            onClick={() => {
                                                handleVariableTransformation(
                                                    'independent',
                                                    xVar.column,
                                                    ''
                                                );
                                            }}
                                        >
                                            None
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {/* Submenu End */}
                            {maxVariables === 1 ? null : <hr></hr>}
                        </div>
                    );
                }

                independentVariables = (
                    <div className={independentVariableClass}>
                        {independentVariables}
                    </div>
                );

                if (maxVariables > xVariables.length) {
                    independentVariables = (
                        <>
                            {independentVariables} {independentVariablesSelect}
                        </>
                    );
                }
            }
        }

        // let copyDataUniqueValuesForColumn = [...dataUniqueValuesForColumn]

        // let mapDataUniqueValuesForColumn = copyDataUniqueValuesForColumn.map(item => (
        //     <Option
        //       disabled={
        //         optionsSelected.length > 1
        //           ? optionsSelected.includes(item)
        //             ? false
        //             : true
        //           : false
        //       }
        //       key={item}
        //     >
        //       {item}
        //     </Option>
        //   ))

        return (
            // <div>
            <>
                <Panel
                    showArrow={false}
                    style={{ borderBottom: '1px solid white' }}
                    header={
                        item.id === props.analysis.analysisActivePanel
                            ? panelHeaderInactive(
                                nameSelectedAnalysis == ''
                                    ? item.name
                                    : nameSelectedAnalysis,
                                item.id
                            )
                            : panelHeaderActive(item.name, item.id)
                    }
                    key={item.id}
                >
                    <hr
                        style={{
                            marginTop: 0,
                            background: '#fff',
                            opacity: '1'
                        }}
                    />

                    {/* <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: 14
                        }}
                    >
                        <div
                            onClick={() => {
                                handleUnivariateClick(item.id);
                            }}
                            className={`analysis-type-univariate ${analysisTypeUnivariate}`}
                        >
                            Univariate
                        </div>
                        <div
                            onClick={() => {
                                handleMultivariateClick(item.id);
                            }}
                            className={`analysis-type-multivariate ${analysisTypeMultivariate}`}
                        >
                            Multivariate
                        </div>
                    </div> */}
                    <div key={item.id}>
                        {item.analysis_type === 'univariate' ? (
                            <>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'end',
                                        marginBottom: '25px'
                                    }}
                                >
                                    <Checkbox.Group
                                        options={plainOptionsUnivariate}
                                        onChange={
                                            handelUnivariateFunctionSelect
                                        }
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            color: 'white'
                                        }}
                                        className="checkbox-main"
                                        value={item.analysis_function}
                                    />
                                    <SelectDataToDisplay
                                        analysis={props.analysis}
                                        analysisId={props.analysis.analysisId}
                                        handleSetStatistics={
                                            handleSetStatistics
                                        }
                                    />
                                </div>
                                {item.analysis_function.length ? (
                                    <div ref={refD}>
                                        {/* Timeplot X-axis type selection (only shown when timeplot is selected) */}
                                        {item.analysis_function.includes('timeplot') ? (
                                            <>
                                                {/* X-axis type selection */}
                                                <label
                                                    style={{}}
                                                    className="label-analysis"
                                                >
                                                    X-Axis Type
                                                </label>
                                                <div className="project-conditional-card">
                                                    <div
                                                        onClick={() => {
                                                            handleShowListBox('timeplot_xaxis');
                                                            let newAnalysisFormErrors = [...analysisFormErrors];
                                                            newAnalysisFormErrors =
                                                                newAnalysisFormErrors.filter((item) => {
                                                                    return item != 'timeplotXAxis';
                                                                });
                                                            setAnalysisFormErrors(newAnalysisFormErrors);
                                                        }}
                                                        className="select-box-white"
                                                    >
                                                        <div
                                                            className="title-var-right"
                                                            style={{ width: 'auto' }}
                                                        >
                                                            {item.variables.timeplot_xaxis_type?.type === 'year' ? 'Date' : 'Index'}
                                                        </div>
                                                        <div>
                                                            <img
                                                                className="icon-arrow-down"
                                                                src={icon_arrow_down_light}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={
                                                            showListBox === 'timeplot_xaxis'
                                                                ? 'select-list-box-white'
                                                                : 'd-none'
                                                        }
                                                    >
                                                        <ul
                                                            style={{ marginLeft: '-230px', maxHeight: '300px', width: '230px', minWidth: '230px', maxWidth: '230px' }}
                                                            onClick={() => {
                                                                handleShowListBox('timeplot_xaxis');
                                                            }}
                                                        >
                                                            {xAxisTypeList}
                                                        </ul>
                                                    </div>
                                                </div>

                                                {/* Time column selector (only shown when Year is selected) */}
                                                {item.variables.timeplot_xaxis_type?.type === 'year' && (
                                                    <>
                                                        <label
                                                            style={{
                                                                marginTop: '15px',
                                                            }}
                                                            className="label-analysis"
                                                        >
                                                            Date Column
                                                        </label>
                                                        <Tooltip
                                                            visible={
                                                                analysisFormErrors.includes('timeplotTimeColumn')
                                                                    ? true
                                                                    : false
                                                            }
                                                            placement="right"
                                                            color="#fff"
                                                            title={() => {
                                                                return (
                                                                    <div
                                                                        style={{
                                                                            padding: '14px 12px',
                                                                            color: '#3D3F4D',
                                                                            fontFamily: 'Roboto Medium',
                                                                            fontSize: '14px',
                                                                            lineHeight: '17px'
                                                                        }}
                                                                    >
                                                                        Please select time column
                                                                    </div>
                                                                );
                                                            }}
                                                        >
                                                            <div className="project-conditional-card">
                                                                <div
                                                                    onClick={() => {
                                                                        handleShowListBox('timeplot_time_column');
                                                                        let newAnalysisFormErrors = [...analysisFormErrors];
                                                                        newAnalysisFormErrors =
                                                                            newAnalysisFormErrors.filter((item) => {
                                                                                return item != 'timeplotTimeColumn';
                                                                            });
                                                                        setAnalysisFormErrors(newAnalysisFormErrors);
                                                                    }}
                                                                    className="select-box-white"
                                                                >
                                                                    <div
                                                                        className="title-var-right"
                                                                        style={{ width: 'auto' }}
                                                                    >
                                                                        {item.variables.timeplot_xaxis_type?.time_column_json?.column_index
                                                                            ? variablesNames[item.variables.timeplot_xaxis_type.time_column_json.column_index]?.columnName || 'Select column'
                                                                            : 'Select column'}
                                                                    </div>
                                                                    <div>
                                                                        <img
                                                                            className="icon-arrow-down"
                                                                            src={icon_arrow_down_light}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        showListBox === 'timeplot_time_column'
                                                                            ? 'select-list-box-white'
                                                                            : 'd-none'
                                                                    }
                                                                >
                                                                    <ul
                                                                        style={{ marginLeft: '-230px', maxHeight: '300px', overflow: 'auto', width: '230px', minWidth: '230px', maxWidth: '230px' }}
                                                                        onClick={() => {
                                                                            handleShowListBox('timeplot_time_column');
                                                                        }}
                                                                    >
                                                                        {availableColumnListForTimeColumn}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </Tooltip>
                                                    </>
                                                )}
                                            </>
                                        ) : null}

                                        <label
                                            style={{
                                                marginTop: item.analysis_function.includes('timeplot') ? '15px' : '0px'
                                            }}
                                            className="label-analysis"
                                        >
                                            Dependent Variable
                                        </label>

                                        {dependentVariable}
                                        <label
                                            style={{ marginTop: '10px' }}
                                            className="label-remove-outliers"
                                        >
                                            Remove Outliers
                                            <Switch
                                                style={{ marginLeft: '10px' }}
                                                size="small"
                                                checkedChildren="Yes"
                                                unCheckedChildren="No"
                                                checked={item.remove_outliers}
                                                onChange={
                                                    handelRemoveOutliersChange
                                                }
                                            />
                                        </label>
                                        <div
                                            className={
                                                transformMenuIsOpen ===
                                                    yVariable.column
                                                    ? 'transform-menu-container'
                                                    : 'd-none'
                                            }
                                        >
                                            <div
                                                className="transform-menu-box"
                                                style={{ marginTop: -35 }}
                                            >
                                                <ul>
                                                    <li
                                                        onClick={() => {
                                                            handleVariableTransformation(
                                                                'dependent',
                                                                item.id,
                                                                'log'
                                                            );
                                                        }}
                                                    >
                                                        Ln
                                                    </li>
                                                    <li
                                                        onClick={() => {
                                                            handleVariableTransformation(
                                                                'dependent',
                                                                item.id,
                                                                'FirstDiff'
                                                            );
                                                        }}
                                                    >
                                                        First Difference
                                                    </li>


                                                    <li
                                                        onClick={() => {
                                                            handleVariableTransformation(
                                                                'dependent',
                                                                item.id,
                                                                ''
                                                            );
                                                        }}
                                                    >
                                                        None
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        {/*                                        <div>
                                            <label
                                                style={{
                                                    marginTop: '24px',
                                                }}
                                                className="label-remove-outliers"
                                            >
                                                Filter By Column Value
                                                <Switch
                                                    style={{ marginLeft: '10px' }}
                                                    size="small"
                                                    checkedChildren="Yes"
                                                    unCheckedChildren="No"
                                                    checked={item.filter_by_variable}
                                                    onChange={
                                                        handelFilterByCatgoryChange
                                                    }
                                                />
                                            </label>
                                            {item.filter_by_variable ? (
                                                <div className='filtered__box'>
                                                    
                                                        <Select
                                                            suffixIcon={<CustomIcon/>}
                                                            showSearch
                                                            style={{ width: '100%',  marginTop: 10 }}
                                                            value={props.analysis.analysisData[props.analysis.analysisActivePanel]?.filter_by_variable_json?.column_index}
                                                            placeholder="Select Column"
                                                            dropdownClassName='filtered-select-dropdown'
                                                            // optionFilterProp="children"
                                                            // filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                                            // filterSort={(optionA, optionB) =>
                                                            // (optionA?.label ?? '')
                                                            //     .toLowerCase()
                                                            //     .localeCompare((optionB?.label ?? '').toLowerCase())
                                                            // }
                                                            onChange={handleSelectedColumnChange}
                                                            dropdownAlign={{ offset:[0,0] }}
                                                            options={newArrayOfColumn}
                                                        />
                                                        {filteredColumnTooltip}

                                                        <Select
                                                            suffixIcon={<CustomIcon/>}
                                                            showSearch
                                                            style={{ width: '100%',  marginTop: 15 }}
                                                            value={props.analysis.analysisData[props.analysis.analysisActivePanel]?.filter_by_variable_json?.column_value}
                                                            placeholder="Select Value"
                                                            dropdownAlign={{ offset:[0,0] }}
                                                            dropdownClassName='filtered-select-dropdown'
                                                            // optionFilterProp="children"
                                                            // filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                                            // filterSort={(optionA, optionB) =>
                                                            // (optionA?.label ?? '')
                                                            //     .toLowerCase()
                                                            //     .localeCompare((optionB?.label ?? '').toLowerCase())
                                                            // }
                                                            onChange={handleSelectedUniqueChange}
                                                            options={dataUniqueValuesForColumn}
                                                        />
                                                        {filteredVariableTooltip}
                                                    
                                                    
                                                    

                                                </div>
                                            ):null}

                                            
                                        </div> */}
                                        {newArrayOfCategoricalColumns.length && item.analysis_function.includes('boxplot') ? (
                                            <div>

                                                <label
                                                    style={{
                                                        marginTop: '24px',
                                                    }}
                                                    className="label-remove-outliers"
                                                >
                                                    Boxplot By Column
                                                    <Switch
                                                        style={{ marginLeft: '10px' }}
                                                        size="small"
                                                        checkedChildren="Yes"
                                                        unCheckedChildren="No"
                                                        checked={item.statistics_by_variable}
                                                        onChange={
                                                            handleStatisticsByVariableChange
                                                        }
                                                    />
                                                </label>
                                                {item.statistics_by_variable ? (
                                                    <div className='filtered__box'>
                                                        {/* <Select
                                                        size="middle"
                                                        defaultValue=""
                                                        onChange={(e)=>{console.log(e)}}
                                                        style={{ width: 200 }}
                                                        options={[{label:'a10', value: '10'},{label:'b10', value: '11'},{label:'v10', value: '12'},{label:'d10', value: '13'}]}
                                                    /> */}
                                                        {/* <Select
                                                        mode="multiple"
                                                        allowClear
                                                        showSearch
                                                        // value={'sss'}
                                                        style={{ width: '100%' }}
                                                        placeholder="Select value"
                                                        defaultValue={dataUniqueValuesForColumn[0]?.value}
                                                        onChange={handleSelectedUniqueChange}
                                                        options={dataUniqueValuesForColumn}
                                                    >
                                                    </Select> */}
                                                        {/* {dataUniqueValuesForColumn.length == 0 ? (
                                                        null
                                                    ):( */}
                                                        <Select
                                                            suffixIcon={<CustomIcon />}
                                                            showSearch
                                                            style={{ width: '100%', marginTop: 10 }}
                                                            value={props.analysis.analysisData[props.analysis.analysisActivePanel]?.statistics_by_variable_json?.column_index}
                                                            placeholder="Select Column"
                                                            dropdownClassName='filtered-select-dropdown'
                                                            // optionFilterProp="children"
                                                            // filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                                            // filterSort={(optionA, optionB) =>
                                                            // (optionA?.label ?? '')
                                                            //     .toLowerCase()
                                                            //     .localeCompare((optionB?.label ?? '').toLowerCase())
                                                            // }
                                                            onChange={handleSelectedStatisticsByColumnChange}
                                                            dropdownAlign={{ offset: [0, 0] }}
                                                            options={newArrayOfCategoricalColumns}
                                                        />
                                                        {filteredColumnTooltip}

                                                        {filteredVariableTooltip}
                                                        {/* )} */}



                                                        {/* <Input placeholder="Insert value" value={filteredValue} onChange={e=>{setFilteredValue(e.target.value)}}/> */}
                                                    </div>
                                                ) : null}
                                            </div>
                                        ) : null}



                                        <div style={{ textAlign: 'right' }}>
                                            <button
                                                className="button-apply"
                                                onClick={() => {
                                                    sendDataUpdateAnalysis(
                                                        item.id,
                                                        item.analysis_function,
                                                        item.variables,
                                                        // item.name,
                                                        nameSelectedAnalysis ==
                                                            ''
                                                            ? item.name
                                                            : nameSelectedAnalysis,
                                                        item.project,
                                                        item.analysis_type,
                                                        item.remove_outliers,
                                                        item.filter_by_variable,
                                                        item.filter_by_variable_json,
                                                        item.statistics_by_variable,
                                                        item.statistics_by_variable_json
                                                    );
                                                }}
                                            >
                                                <div
                                                    style={{ marginTop: '3px' }}
                                                >
                                                    {/* {item.id == 0
                                                        ? 'CREATE'
                                                        : 'APPLY'}
                                                         */}
                                                    {JSON.stringify(
                                                        props.analysis
                                                            .rawAnalysisData
                                                    ) ===
                                                        JSON.stringify(
                                                            props.analysis
                                                                .analysisData
                                                        )
                                                        ? 'APPLY'
                                                        : ' APPLY (1)'}
                                                    {spinnerApply && (
                                                        <div className="lds-dual-ring-small"></div>
                                                    )}
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                ) : null}
                            </>
                        ) : appContext.defaults.sub_is_active ? (
                            <>
                                <Checkbox.Group
                                    options={plainOptionsMultivariate}
                                    onChange={handelMultivariateFunctionSelect}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        color: 'white',
                                        marginBottom: 20
                                    }}
                                    className="checkbox-main"
                                    value={item.analysis_function}
                                />

                                {item.analysis_function.length ? (
                                    <div ref={refD}>
                                        {item.analysis_function.includes('timeplot') ? (
                                            // Timeplot-specific variable selector
                                            <>
                                                {/* X-axis type selection */}
                                                <label
                                                    style={{}}
                                                    className="label-analysis"
                                                >
                                                    X-Axis Type
                                                </label>
                                                <div className="project-conditional-card">
                                                    <div
                                                        onClick={() => {
                                                            handleShowListBox('timeplot_xaxis');
                                                            let newAnalysisFormErrors = [...analysisFormErrors];
                                                            newAnalysisFormErrors =
                                                                newAnalysisFormErrors.filter((item) => {
                                                                    return item != 'timeplotXAxis';
                                                                });
                                                            setAnalysisFormErrors(newAnalysisFormErrors);
                                                        }}
                                                        className="select-box-white"
                                                    >
                                                        <div
                                                            className="title-var-right"
                                                            style={{ width: 'auto' }}
                                                        >
                                                            {item.variables.timeplot_xaxis_type?.type === 'year' ? 'Date' : 'Index'}
                                                        </div>
                                                        <div>
                                                            <img
                                                                className="icon-arrow-down"
                                                                src={icon_arrow_down_light}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={
                                                            showListBox === 'timeplot_xaxis'
                                                                ? 'select-list-box-white'
                                                                : 'd-none'
                                                        }
                                                    >
                                                        <ul
                                                            style={{ marginLeft: '-230px', maxHeight: '300px', width: '230px', minWidth: '230px', maxWidth: '230px' }}
                                                            onClick={() => {
                                                                handleShowListBox('timeplot_xaxis');
                                                            }}
                                                        >
                                                            {xAxisTypeList}
                                                        </ul>
                                                    </div>
                                                </div>

                                                {/* Time column selector (only shown when Year is selected) */}
                                                {item.variables.timeplot_xaxis_type?.type === 'year' && (
                                                    <>
                                                        <label
                                                            style={{
                                                                marginTop: '15px',
                                                                // marginBottom: '10px'
                                                            }}
                                                            className="label-analysis"
                                                        >
                                                            Date Column
                                                        </label>
                                                        <Tooltip
                                                            visible={
                                                                analysisFormErrors.includes('timeplotTimeColumn')
                                                                    ? true
                                                                    : false
                                                            }
                                                            placement="right"
                                                            color="#fff"
                                                            title={() => {
                                                                return (
                                                                    <div
                                                                        style={{
                                                                            padding: '14px 12px',
                                                                            color: '#3D3F4D',
                                                                            fontFamily: 'Roboto Medium',
                                                                            fontSize: '14px',
                                                                            lineHeight: '17px'
                                                                        }}
                                                                    >
                                                                        Please select time column
                                                                    </div>
                                                                );
                                                            }}
                                                        >
                                                            <div className="project-conditional-card">
                                                                <div
                                                                    onClick={() => {
                                                                        handleShowListBox('timeplot_time_column');
                                                                        let newAnalysisFormErrors = [...analysisFormErrors];
                                                                        newAnalysisFormErrors =
                                                                            newAnalysisFormErrors.filter((item) => {
                                                                                return item != 'timeplotTimeColumn';
                                                                            });
                                                                        setAnalysisFormErrors(newAnalysisFormErrors);
                                                                    }}
                                                                    className="select-box-white"
                                                                >
                                                                    <div
                                                                        className="title-var-right"
                                                                        style={{ width: 'auto' }}
                                                                    >
                                                                        {item.variables.timeplot_xaxis_type?.time_column_json?.column_index
                                                                            ? variablesNames[item.variables.timeplot_xaxis_type.time_column_json.column_index]?.columnName || 'Select column'
                                                                            : 'Select column'}
                                                                    </div>
                                                                    <div>
                                                                        <img
                                                                            className="icon-arrow-down"
                                                                            src={icon_arrow_down_light}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        showListBox === 'timeplot_time_column'
                                                                            ? 'select-list-box-white'
                                                                            : 'd-none'
                                                                    }
                                                                >
                                                                    <ul
                                                                        style={{ marginLeft: '-230px', maxHeight: '300px', overflow: 'auto', width: '230px', minWidth: '230px', maxWidth: '230px' }}
                                                                        onClick={() => {
                                                                            handleShowListBox('timeplot_time_column');
                                                                        }}
                                                                    >
                                                                        {availableColumnListForTimeColumn}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </Tooltip>
                                                    </>
                                                )}

                                                <label
                                                    style={{
                                                        marginTop: '15px',
                                                        marginBottom: '5px'
                                                    }}
                                                    className="label-analysis"
                                                >
                                                    Variables
                                                </label>
                                                {(() => {
                                                    // Get all selected variables (Y + X)
                                                    const allTimeplotVariables = [];
                                                    if (item.variables.Y.column) {
                                                        allTimeplotVariables.push({
                                                            column: item.variables.Y.column,
                                                            trans: item.variables.Y.trans,
                                                            isY: true
                                                        });
                                                    }
                                                    item.variables.X.forEach(xVar => {
                                                        allTimeplotVariables.push({
                                                            column: xVar.column,
                                                            trans: xVar.trans,
                                                            isY: false
                                                        });
                                                    });

                                                    // Build timeplot variable class (with red-border when active)
                                                    let timeplotVariableClass = ['independent-variables-box'];
                                                    if (
                                                        item.id === inputVariableTaker.analysis_id &&
                                                        inputVariableTaker.variable === 'timeplot' &&
                                                        inputVariableTaker.taker
                                                    )
                                                        timeplotVariableClass.push('red-border');
                                                    timeplotVariableClass = timeplotVariableClass.join(' ');

                                                    // Build the timeplot variables display
                                                    let timeplotVariablesDisplay = [];

                                                    allTimeplotVariables.forEach((varItem, index) => {
                                                        const varName = variablesNames[varItem.column]?.columnName || '';
                                                        // Get the current transformation from the item state (not from varItem which might be stale)
                                                        const currentTrans = varItem.isY
                                                            ? item.variables.Y.trans
                                                            : item.variables.X.find(x => String(x.column) === String(varItem.column))?.trans || '';
                                                        const transLabel = currentTrans && transDisplayName[currentTrans]
                                                            ? `${transDisplayName[currentTrans]} | `
                                                            : '';
                                                        const transformMenuKey = `timeplot-${varItem.isY ? 'y' : 'x'}-${varItem.column}`;
                                                        const variableType = varItem.isY ? 'dependent' : 'independent';
                                                        const handleTransformSelection = (transform) => {
                                                            handleVariableTransformation(
                                                                variableType,
                                                                varItem.isY ? item.id : varItem.column,
                                                                transform
                                                            );
                                                        };

                                                        timeplotVariablesDisplay.push(
                                                            <div key={`timeplot-${varItem.column}-${index}`}>
                                                                <div className="independent-variables">
                                                                    <div className="title">{`${transLabel}${varName}`}</div>
                                                                    <div className="icons">
                                                                        <Tooltip placement="top" title='Add Transform'>
                                                                            <img
                                                                                className="icon-transform"
                                                                                onClick={() => {
                                                                                    handleOpenAndCloseTransformMenu(transformMenuKey);
                                                                                }}
                                                                                src={icon_transform}
                                                                            />
                                                                        </Tooltip>
                                                                        <Tooltip placement="top" title='Remove Variable'>
                                                                            <img
                                                                                onClick={() => {
                                                                                    handleDeleteTimeplotVariable(varItem.column);
                                                                                }}
                                                                                src={icon_circle_minus}
                                                                            />
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        transformMenuIsOpen === transformMenuKey
                                                                            ? 'transform-menu-container'
                                                                            : 'd-none'
                                                                    }
                                                                >
                                                                    <div className="transform-menu-box">
                                                                        <ul>
                                                                            <li
                                                                                onClick={() => {
                                                                                    handleTransformSelection('log');
                                                                                }}
                                                                            >
                                                                                Ln
                                                                            </li>
                                                                            <li
                                                                                onClick={() => {
                                                                                    handleTransformSelection('FirstDiff');
                                                                                }}
                                                                            >
                                                                                First Difference
                                                                            </li>
                                                                            <li
                                                                                onClick={() => {
                                                                                    handleTransformSelection('');
                                                                                }}
                                                                            >
                                                                                None
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                                {index < allTimeplotVariables.length - 1 ? <hr></hr> : null}
                                                            </div>
                                                        );
                                                    });

                                                    // Create the selector box (matching independent variables structure exactly)
                                                    const timeplotVariableSelector = (
                                                        <div className="project-conditional-card-top">
                                                            <Tooltip
                                                                visible={
                                                                    analysisFormErrors.includes('timeplot')
                                                                        ? true
                                                                        : false
                                                                }
                                                                placement="right"
                                                                color="#fff"
                                                                title={() => {
                                                                    return (
                                                                        <div
                                                                            style={{
                                                                                padding: '14px 12px',
                                                                                color: '#3D3F4D',
                                                                                fontFamily: 'Roboto Medium',
                                                                                fontSize: '14px',
                                                                                lineHeight: '17px'
                                                                            }}
                                                                        >
                                                                            Please provide variable
                                                                        </div>
                                                                    );
                                                                }}
                                                            >
                                                                <div
                                                                    onClick={() => {
                                                                        handleShowListBox('timeplot');
                                                                        let newAnalysisFormErrors = [...analysisFormErrors];
                                                                        newAnalysisFormErrors =
                                                                            newAnalysisFormErrors.filter((item) => {
                                                                                return item != 'timeplot';
                                                                            });
                                                                        setAnalysisFormErrors(newAnalysisFormErrors);
                                                                    }}
                                                                    className="select-box-white-border"
                                                                >
                                                                    <div
                                                                        className="title-var-right"
                                                                        style={{ width: 'auto' }}
                                                                    >
                                                                        Select column
                                                                    </div>
                                                                    <div>
                                                                        <img
                                                                            className="icon-arrow-down"
                                                                            src={icon_arrow_down_light}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </Tooltip>
                                                            <div
                                                                className={
                                                                    showListBox === 'timeplot' ? 'select-list-box-white' : 'd-none'
                                                                }
                                                            >
                                                                <ul
                                                                    style={{ marginLeft: '-230px', maxHeight: '300px', overflow: 'auto' }}
                                                                    onClick={() => {
                                                                        handleShowListBox('timeplot');
                                                                    }}
                                                                >
                                                                    {availableColumnList}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    );

                                                    // Build the final structure matching independent variables
                                                    let timeplotVariables = timeplotVariableSelector;

                                                    if (allTimeplotVariables.length > 0) {
                                                        timeplotVariables = (
                                                            <div className={timeplotVariableClass}>
                                                                {timeplotVariablesDisplay}
                                                            </div>
                                                        );

                                                        // Show selector only if under max limit (5 variables)
                                                        const maxTimeplotVariables = 5;
                                                        if (allTimeplotVariables.length < maxTimeplotVariables) {
                                                            timeplotVariables = (
                                                                <>
                                                                    {timeplotVariables} {timeplotVariableSelector}
                                                                </>
                                                            );
                                                        }
                                                    }

                                                    return timeplotVariables;
                                                })()}
                                            </>
                                        ) : (
                                            // Standard dependent/independent variable selectors
                                            <>
                                                <label
                                                    style={{}}
                                                    className="label-analysis"
                                                >
                                                    Dependent Variable
                                                </label>
                                                {dependentVariable}
                                                <label
                                                    style={{
                                                        marginTop: '10px',
                                                        marginBottom: '10px'
                                                    }}
                                                    className="label-remove-outliers"
                                                >
                                                    Remove Outliers
                                                    <Switch
                                                        style={{ marginLeft: '10px' }}
                                                        size="small"
                                                        checkedChildren="Yes"
                                                        unCheckedChildren="No"
                                                        checked={item.remove_outliers}
                                                        onChange={
                                                            handelRemoveOutliersChange
                                                        }
                                                    />
                                                </label>

                                                <div
                                                    className={
                                                        transformMenuIsOpen ===
                                                            yVariable.column
                                                            ? 'transform-menu-container'
                                                            : 'd-none'
                                                    }
                                                >
                                                    <div
                                                        className="transform-menu-box"
                                                        style={{ marginTop: -44 }}
                                                    >
                                                        <ul>
                                                            <li
                                                                onClick={() => {
                                                                    handleVariableTransformation(
                                                                        'dependent',
                                                                        item.id,
                                                                        'log'
                                                                    );
                                                                }}
                                                            >
                                                                Ln
                                                            </li>
                                                            <li
                                                                onClick={() => {
                                                                    handleVariableTransformation(
                                                                        'dependent',
                                                                        item.id,
                                                                        'FirstDiff'
                                                                    );
                                                                }}
                                                            >
                                                                First Difference
                                                            </li>

                                                            {/* <li
                                                            onClick={() => {
                                                                handleVariableTransformation(
                                                                    'dependent',
                                                                    item.id,
                                                                    'lag1'
                                                                );
                                                            }}
                                                        >
                                                            Lag (1)
                                                        </li> */}
                                                            {/* <li
                                                            onClick={() => {
                                                                handleVariableTransformation(
                                                                    'dependent',
                                                                    item.id,
                                                                    'sqrt'
                                                                );
                                                            }}
                                                        >
                                                            Sqrt
                                                        </li> */}
                                                            <li
                                                                onClick={() => {
                                                                    handleVariableTransformation(
                                                                        'dependent',
                                                                        item.id,
                                                                        ''
                                                                    );
                                                                }}
                                                            >
                                                                None
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <label
                                                    style={{
                                                        marginTop: '10px',
                                                        marginBottom: '6px'
                                                    }}
                                                    className="label-analysis"
                                                >
                                                    {item.analysis_function.includes('two_stage_least_squares')
                                                        ? 'Endogenous & Exogenous Regressors'
                                                        : 'Independent Variable/s'}
                                                </label>
                                                {independentVariables}
                                                {item.analysis_function.includes('two_stage_least_squares') && (() => {
                                                    const zList = Array.isArray(item.variables['Z']) ? item.variables['Z'] : [];
                                                    const canAddMore = zList.length < 3;
                                                    const isActive =
                                                        item.id === inputVariableTaker.analysis_id &&
                                                        inputVariableTaker.variable === 'Z' &&
                                                        inputVariableTaker.taker;
                                                    return (
                                                        <>
                                                            <label
                                                                style={{ marginTop: '10px', marginBottom: '6px' }}
                                                                className="label-analysis"
                                                            >
                                                                Instrument Variable/s (Z) - max 3
                                                            </label>
                                                            {zList.map((zVar) => {
                                                                const zClass = [
                                                                    'dependent-variable-box',
                                                                    isActive ? 'red-border' : ''
                                                                ].join(' ').trim();
                                                                return (
                                                                    <div key={zVar.column} className={zClass}>
                                                                        <div className="dependent-variable">
                                                                            <div className="title">
                                                                                {variablesNames[zVar.column]
                                                                                    ? variablesNames[zVar.column].columnName
                                                                                    : zVar.column}
                                                                            </div>
                                                                            <div className="icons">
                                                                                <Tooltip placement="top" title="Remove Instrument Variable">
                                                                                    <img
                                                                                        onClick={() => handleDeleteInstrumentVariable(zVar.column)}
                                                                                        src={icon_circle_minus}
                                                                                    />
                                                                                </Tooltip>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                            {canAddMore && (
                                                                <div className="project-conditional-card">
                                                                    <div
                                                                        onClick={() => handleShowListBox('Z')}
                                                                        className="select-box-white"
                                                                    >
                                                                        <div className="title-var-right" style={{ width: 'auto' }}>
                                                                            Select column
                                                                        </div>
                                                                        <div>
                                                                            <img className="icon-arrow-down" src={icon_arrow_down_light} />
                                                                        </div>
                                                                    </div>
                                                                    <div className={showListBox === 'Z' ? 'select-list-box-white' : 'd-none'}>
                                                                        <ul
                                                                            style={{ marginLeft: '-230px', maxHeight: '300px' }}
                                                                            onClick={() => handleShowListBox('Z')}
                                                                        >
                                                                            {availableColumnList}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                            </>
                                        )}


                                        {item.analysis_function.includes('robust_regression') ? (
                                            <>
                                                <label
                                                    style={{
                                                        marginTop: '30px',
                                                    }}
                                                    className="label-remove-outliers"
                                                >
                                                    Filter By Column Value
                                                    <Switch
                                                        style={{ marginLeft: '10px' }}
                                                        size="small"
                                                        checkedChildren="Yes"
                                                        unCheckedChildren="No"
                                                        checked={item.filter_by_variable}
                                                        onChange={
                                                            handelFilterByCatgoryChange
                                                        }
                                                    />
                                                </label>
                                                {item.filter_by_variable ? (
                                                    <div className='filtered__box'>
                                                        {/* {filteredVariable} */}
                                                        {/* <Select
                                                            size="middle"
                                                            defaultValue=""
                                                            onChange={(e)=>{console.log(e)}}
                                                            style={{ width: 200 }}
                                                            options={[{label:'a10', value: '10'},{label:'b10', value: '11'},{label:'v10', value: '12'},{label:'d10', value: '13'}]}
                                                        /> */}
                                                        {/* <Select
                                                            mode="multiple"
                                                            allowClear
                                                            showSearch
                                                            // value={'sss'}
                                                            style={{ width: '100%' }}
                                                            placeholder="Select value"
                                                            defaultValue={dataUniqueValuesForColumn[0]?.value}
                                                            onChange={handleSelectedUniqueChange}
                                                            options={dataUniqueValuesForColumn}
                                                        >
                                                        </Select> */}
                                                        {/* {dataUniqueValuesForColumn.length == 0 ? (
                                                            null
                                                        ):( */}
                                                        <Select
                                                            suffixIcon={<CustomIcon />}
                                                            style={{ width: '100%', marginTop: 10 }}
                                                            value={props.analysis.analysisData[props.analysis.analysisActivePanel]?.filter_by_variable_json?.column_index}
                                                            placeholder="Select Column"
                                                            dropdownAlign={{ offset: [0, 0] }}
                                                            dropdownClassName='filtered-select-dropdown'
                                                            // optionFilterProp="children"
                                                            // filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                                            // filterSort={(optionA, optionB) =>
                                                            // (optionA?.label ?? '')
                                                            //     .toLowerCase()
                                                            //     .localeCompare((optionB?.label ?? '').toLowerCase())
                                                            // }
                                                            onChange={handleSelectedColumnChange}
                                                            options={newArrayOfColumn}
                                                        />
                                                        {filteredColumnTooltip}
                                                        <Select
                                                            suffixIcon={<CustomIcon />}
                                                            style={{ width: '100%', marginTop: 15 }}
                                                            value={props.analysis.analysisData[props.analysis.analysisActivePanel]?.filter_by_variable_json?.column_value}
                                                            placeholder="Select Value"
                                                            dropdownAlign={{ offset: [0, 0] }}
                                                            dropdownClassName='filtered-select-dropdown'
                                                            // optionFilterProp="children"
                                                            // filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                                            // filterSort={(optionA, optionB) =>
                                                            // (optionA?.label ?? '')
                                                            //     .toLowerCase()
                                                            //     .localeCompare((optionB?.label ?? '').toLowerCase())
                                                            // }
                                                            onChange={handleSelectedUniqueChange}
                                                            options={dataUniqueValuesForColumn}
                                                        />
                                                        {filteredVariableTooltip}
                                                        {/* )} */}



                                                        {/* <Input placeholder="Insert value" value={filteredValue} onChange={e=>{setFilteredValue(e.target.value)}}/> */}
                                                    </div>
                                                ) : null}


                                            </>
                                        ) : null}



                                        <div style={{ textAlign: 'right' }}>
                                            <button
                                                className="button-apply"
                                                onClick={() => {
                                                    sendDataUpdateAnalysis(
                                                        item.id,
                                                        item.analysis_function,
                                                        item.variables,
                                                        // item.name,
                                                        nameSelectedAnalysis ==
                                                            ''
                                                            ? item.name
                                                            : nameSelectedAnalysis,
                                                        item.project,
                                                        item.analysis_type,
                                                        item.remove_outliers,
                                                        item.filter_by_variable,
                                                        item.filter_by_variable_json,
                                                        item.statistics_by_variable,
                                                        item.statistics_by_variable_json

                                                    );
                                                }}
                                            >
                                                <div
                                                    style={{ marginTop: '3px' }}
                                                >
                                                    {/* {item.id == 0
                                                        ? 'CREATE'
                                                        : 'APPLY'} */}
                                                    APPLY
                                                    {spinnerApply ? (
                                                        <div className="lds-dual-ring-small"></div>
                                                    ) : null}
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        ) : (
                            <>
                                <div
                                    className="go-pro-button"
                                    onClick={() => {
                                        setShowModalGoPro(true);
                                    }}
                                >
                                    go pro
                                </div>
                            </>
                        )}
                    </div>
                </Panel>
            </>
            // </div>
        );
    });

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: 14,
                    justifyContent: 'space-between',
                    marginRight: '20px',
                    marginTop: '10px'
                }}
            >
                <div
                    onClick={() => {
                        handleStartNewAnalysis('univariate');
                    }}
                    style={{
                        fontFamily: 'Roboto Regular',
                        fontSize: '16px',
                        cursor: 'pointer',
                        display: 'flex'

                    }}
                >
                    <img style={{ marginRight: '9px' }} src={icon_plus} />
                    <div>Univariate</div>

                </div>
                <div
                    style={{
                        borderLeft: '1px solid #fff',
                        // margin: '0 -18px'
                    }}
                ></div>
                <div
                    onClick={() => {
                        handleStartNewAnalysis('multivariate');
                    }}
                    style={{
                        fontFamily: 'Roboto Regular',
                        fontSize: '16px',
                        cursor: 'pointer',
                        display: 'flex'
                    }}
                >
                    <img style={{ marginRight: '9px' }} src={icon_plus} />
                    <div>Multivariate</div>
                    {!appContext.defaults.sub_is_active ? (
                        <img
                            src={version_pro}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '14px'
                            }}
                        />
                    ) : null}
                </div>
            </div>

            <hr
                style={{
                    marginTop: '0px',
                    background: '#fff',
                    opacity: 1,
                    width: '230px',
                    margin: '0 0 4px 0'
                }}
            />

            <div className="analysis-container-box">
                <div
                // ref={menuRef}
                >
                    <Collapse
                        className="secondsideranalysis-collapse"
                        ghost
                        accordion
                        collapsible="header"
                        activeKey={props.analysis.analysisActivePanel}
                    >
                        {analysisData}
                    </Collapse>
                </div>
            </div>
            <RenameModal
                visible={isModalVisibleRename}
                onAccept={handleOkRename}
                onCancel={handleCancel}
                handleNewRename={handleChangeRename}
                currentName={nameSelectedAnalysis}
                modalType="renameAnalysis"
            />

            {props.analysis.analysisActivePanel == 0 ? (
                <CancelModal
                    visible={isModalVisibleRemove}
                    onAccept={handleOkRemove}
                    onCancel={handleCancel}
                    modalType="cancelAnalysis"
                />
            ) : (
                <DeleteModal
                    visible={isModalVisibleRemove}
                    onAccept={handleOkRemove}
                    onCancel={handleCancel}
                    modalType="deleteAnalysis"
                />
            )}

            <Modal
                className="custom-modal-go-pro"
                title=""
                visible={showModalGoPro}
                // onOk={handleOkPreloaded}
                onCancel={() => {
                    setShowModalGoPro(false);
                }}
                footer={null}
                closable={false}
                bodyStyle={{ minHeight: 574 }}
                width={700}
            >
                <div className="header">
                    <div className="title">Go Pro for full functionality.</div>
                </div>
                <div className="body">
                    <div className="container1">
                        <div className="con-header">
                            <img src={econometrica_logo_popup} />
                        </div>
                        <div className="hr"></div>
                        <div className="con-body">
                            <div className="desc-bold">Projects</div>
                            <div className="desc-bold">Transformation</div>
                            <div className="desc-bold">Analysis</div>
                            <div className="desc">Scatterplot</div>
                            <div className="desc">Regression</div>
                            <div className="desc">Koyck</div>
                        </div>
                    </div>
                    <div className="container2">
                        <div className="con-header">
                            <div className="title-bold">Lite</div>
                            <div className="title">FREE</div>
                        </div>
                        <div className="hr"></div>
                        <div className="con-body">
                            <div className="ul">
                                <div className="li">30 projects</div>
                                <div className="li">Numerical</div>
                                <div className="li">Univariate</div>
                                <div className="li">
                                    <img src={icon_x} />
                                </div>
                                <div className="li">
                                    <img src={icon_x} />
                                </div>
                                <div className="li">
                                    <img src={icon_x} />
                                </div>
                            </div>
                            <div
                                onClick={() => {
                                    setShowModalGoPro(false);
                                }}
                                className="btn-go-back"
                            >
                                Go Back to Lite
                            </div>
                        </div>
                    </div>
                    <div className="container3">
                        <div className="con-header">
                            <div className="title-bold">PRO</div>
                            <div className="title">
                                <span className="dolar">$</span>85
                                <span className="year">/ year</span>
                            </div>
                        </div>
                        <div className="hr"></div>
                        <div className="con-body">
                            <div className="ul">
                                <div className="li">60 projects</div>
                                <div className="li">
                                    Numerical & Conditional
                                </div>
                                <div className="li">Uni & Multivariate</div>
                                <div className="li">
                                    <img src={icon_y} />
                                </div>
                                <div className="li">
                                    <img src={icon_y} />
                                </div>
                                <div className="li">
                                    <img src={icon_y} />
                                </div>
                            </div>
                            <div
                                className="btn-go-pro"
                                onClick={() => {
                                    setShowModalGoPro(false);
                                    appContext.setMainUserDetailsDrawerIsVisible(
                                        true
                                    );
                                }}
                            >
                                Go Pro <img src={icon_right} />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

// export default Analysis;
export default React.memo(Analysis);
